import { VerticalSegment } from 'components/verticalSegment'
import { AnswerButtons, PartyButtons } from 'components/answerButtons'
import React, { useContext } from 'react'
import { AnswerPayload } from './actions'
import { QuestionState } from './reducer'
import styles from './questions.module.scss'
import { LocaleContext } from 'contexts/locale'
import { SubmissionStatus } from 'types/submissionStatus'
import questions from './questions.yml'
import { QuestionBlock } from 'components/questionBlock'
import qbs from 'components/questionBlock/questionBlock.module.scss'

interface QuestionsProps {
  selectedAnswers: QuestionState
  submissionStatus: SubmissionStatus
  selectAnswer: (answer: AnswerPayload) => void
}

export const Questions = ({
  selectedAnswers,
  selectAnswer,
  submissionStatus
}: QuestionsProps) => {
  if (submissionStatus === SubmissionStatus.delivered) {
    return null
  }

  const locale = useContext(LocaleContext)
  const questionTranslations = require(`./locales/questions.${locale}.yml`)

  return (
    <VerticalSegment className={qbs.questionBlocks} text>
      {/* Before we map through all the question defined by the questions.yml
      file, we ask for the winning party. Since this requires colourful
       buttons, this is done using it's own component. */}

      <QuestionBlock
        id='allParties'
        question={questionTranslations.questions.allParties.question}
        description={questionTranslations.questions.allParties.description}
      >
        <PartyButtons
          currentSelection={selectedAnswers.allParties || undefined}
          handleAnswer={clickedAnswer => {
            selectAnswer({
              clickedAnswer: clickedAnswer,
              questionId: 'allParties',
              selectionType: 'multiple'
            })
          }}
        />
      </QuestionBlock>

      {questions.map(q => {
        const translatedQuestion = questionTranslations.questions[q.id]

        return (
          <QuestionBlock
            key={q.id}
            id={q.id}
            question={translatedQuestion.question}
            description={translatedQuestion.description}
          >
            <AnswerButtons
              handleAnswer={(clickedAnswer: string | number) => {
                selectAnswer({
                  clickedAnswer: clickedAnswer,
                  questionId: q.id,
                  selectionType: q.selectionType
                })
              }}
              responses={
                q.options &&
                q.options.reduce<{ [key: string]: string }>(
                  (previousValue, currentValue) => {
                    previousValue[currentValue] =
                      translatedQuestion.options[currentValue]
                    return previousValue
                  },
                  {}
                )
              }
              selectionType={q.selectionType}
              currentSelection={selectedAnswers[q.id] || undefined}
            />
          </QuestionBlock>
        )
      })}
    </VerticalSegment>
  )
}
